/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from 'react';
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import {BiEdit, BiPlus, BiTrash} from 'react-icons/bi';
import {Post} from '../../lib/Request';
import {ALERT_VARIANT, ERoleId} from '../../const/dataEnum';
import {useDispatch} from 'react-redux';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {API_ACTION, API_DEPARTMENT} from '../../const/Api';
import {FmlxTable} from 'fmlx-common-ui';
import {getDefaultValue} from '../../lib/utilities';
import './ManageDepartments.scss';

export default function ManageDepartments({userRoleId, departments, onOpenModalClick, fetchDepartments}) {
  const dispatch = useDispatch();
  const defaultDepartment = getDefaultValue('department');

  const [departmentName, setDepartmentName] = useState('');
  const [departmentID, setDepartmentID] = useState(0);
  const [action, setAction] = useState('');
  const [loadingModify, setLoadingModify] = useState(false);

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
      return true;
    }
    return false;
  }

  function validateEntry() {
    return departmentName?.length > 0;
  }

  async function ModifyDepartment(event) {
    event.preventDefault();
    setLoadingModify(true);

    let param = defaultDepartment;
    let url;
    // eslint-disable-next-line default-case
    switch (action) {
      case 'Create':
        param.departmentName = param.longName = departmentName;
        url = API_DEPARTMENT + API_ACTION.CREATE;
        break;
      case 'Update':
        param.departmentName = param.longName = departmentName;
        param.id = departmentID;
        url = API_DEPARTMENT + API_ACTION.UPDATE;
        break;
      case 'Delete':
        param.id = departmentID;
        url = API_DEPARTMENT + API_ACTION.DELETE;
        break;
    }
    let result = await Post(url, param);
    if (!callError(result)) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: result.message}));
      await fetchDepartments(userRoleId);
    } else if (result.responseCode === -9) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: action.Equals('Delete')
            ? `Department ${departmentName} cannot be deleted because there is/are employee(s) associated with the ${departmentName} department`
            : 'The data is invalid',
        })
      );
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
    }
    setAction('');
    setDepartmentID('');
    setDepartmentName('');
    setLoadingModify(false);
  }

  const deletePrompt = (
    <Modal show={action === 'Delete'} centered size="md" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title>Delete Department</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure to delete this department?</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={ModifyDepartment} disabled={loadingModify}>
          {loadingModify ? (
            <div>
              <span
                style={{marginLeft: '0px'}}
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            'Yes'
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            setAction('');
            setDepartmentID(0);
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const createOrUpdatePrompt = (
    <Modal
      show={['Create', 'Update'].includes(action)}
      centered
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Form onSubmit={ModifyDepartment}>
        <Modal.Header>
          <Modal.Title>{action} Department</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col>
              <Form.Group size="lg" controlId="username" className="mb-2">
                <Form.Label>Department Name</Form.Label>
                <Form.Control
                  autoFocus
                  placeholder="Department"
                  type="text"
                  value={departmentName}
                  onChange={(e) => setDepartmentName(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button size="md" type="submit" style={{width: '150px'}} disabled={!validateEntry() || loadingModify}>
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: '0px'}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              'Save Changes'
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setAction('');
              setDepartmentID(defaultDepartment.id);
              setDepartmentName(defaultDepartment.departmentName);
            }}
            disabled={loadingModify}
          >
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );

  const getSelectedRow = (selectedItems, selectedRowIds) => {
    if (selectedItems.length > 0) {
      setDepartmentID(selectedItems[0].id);
    }
  };

  return (
    <div className="manage-department-container">
      <div className="manage-department">
        <div>
          <h4>Department</h4>
        </div>
        <div className="manage-department--button-container">
          {userRoleId === ERoleId.ADMINISTRATOR ? (
            <Button onClick={() => setAction('Create')}>Add Department</Button>
          ) : (
            <></>
          )}
        </div>
        <div className="manage-department--table-container">
          <FmlxTable
            data={departments}
            getSelectedRow={getSelectedRow}
            // isLoading={loadingDepartments}
            columns={[
              {
                Header: 'No',
                accessor: null,
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '20%',
                  minWidth: '20%',
                  maxWidth: '20%',
                },
                Cell: ({value, row}) => {
                  return <>{row.index + 1}</>;
                },
              },
              {
                Header: 'Department',
                accessor: 'departmentName',
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '40%',
                  minWidth: '40%',
                  maxWidth: '40%',
                },
              },
              {
                Header: 'Action',
                accessor: null,
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '40%',
                  minWidth: '40%',
                  maxWidth: '40%',
                },
                Cell: ({value, row}) => {
                  const {original} = row;
                  return (
                    <div style={{display: 'flex', gap: '8px'}}>
                      <Button
                        onClick={() => {
                          setDepartmentID(original.id);
                          setDepartmentName(original.departmentName);
                          setAction('Update');
                        }}
                      >
                        <BiEdit />
                      </Button>
                      {userRoleId === ERoleId.ADMINISTRATOR ? (
                        <Button
                          variant="danger"
                          onClick={() => {
                            setDepartmentID(original.id);
                            setDepartmentName(original.departmentName);
                            setAction('Delete');
                          }}
                        >
                          <BiTrash />
                        </Button>
                      ) : (
                        <></>
                      )}
                      <Button
                        onClick={(e) => {
                          onOpenModalClick(e, original);
                        }}
                      >
                        <BiPlus />
                      </Button>
                    </div>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
      {deletePrompt}
      {createOrUpdatePrompt}
    </div>
  );
}
